const AiChatShareAccessTypes = {
  VIEW: "VIEW",
  EDIT: "EDIT"
} as const;

export default AiChatShareAccessTypes;
